import { defineMessages } from '@cookbook/solid-intl'

// Split out from the page's own messages file so the router's document-title /
// meta-description wiring doesn't pull a whole page catalogue into the
// boot-critical chunk just for these two strings. Same pattern as
// `browser-demo-page-routing.messages.en.js` (TENANT-5036).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'See what the Lodgr browser extension shows you on a listing page, before you install it.',
        id: 'LodgrExtensionDemoPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Extension Demo | Lodgr',
        id: 'LodgrExtensionDemoPage.titleMessage',
    }),
}
